import React from 'react';
import DesktopMenu from './DesktopMenu';
import resources from '../resources';

class SubScreenHeader extends React.Component {
  state = {
    isMobile: window.innerWidth < 768,
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateDevice);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDevice);
  }

  updateDevice = () => {
    this.setState({ isMobile: window.innerWidth < 768 });
  };

  render() {
    const { isMobile } = this.state;

    return (
      <div style={{ position: 'relative', height: isMobile ? '200px' : '280px', overflow: 'hidden' }}>
        {/* Background image */}
        <img
          src={resources.images.SubBackground}
          alt="Sub Background"
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 1,
          }}
        />

        {/* DesktopMenu */}
        <div style={{ position: 'relative', zIndex: 2, maxWidth: 1040, margin: '0 auto' }}>
          <DesktopMenu isMobile={isMobile} showDrawer={() => { }} />
        </div>

        {/* Title block - full width, absolute bottom, left aligned */}
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            zIndex: 3,
            backgroundColor: 'white',
            width: isMobile ? '100%':'60%',
            borderTopRightRadius: isMobile ? 16 : 32,
            borderTopLeftRadius:  isMobile ? 16 : 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          }}
        >
          <div
            style={{
              marginLeft: isMobile ? 0 : `calc((100% - 520px) / 2)`, // để align với logo
              padding: isMobile ? 10 : '24px 32px',
            }}
          >
            <h1
              style={{
                fontSize: isMobile ? 26 : 36,
                fontWeight: 600,
                margin: 0,
                lineHeight: 1.4,
                 fontFamily: 'Inter28-SemiBold'
              }}
            >
              {this.props.title || (
                <>
                  VNG Corporation:<br />A 20-Year Legacy of Innovation
                </>
              )}
            </h1>
          </div>
        </div>

      </div>
    );
  }
}

export default SubScreenHeader;
